/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InvoiceInputs */

const en_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

const es_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factura`)
};

const fr_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facture`)
};

const de_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnung`)
};

const ja_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求書`)
};

const zh_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发票`)
};

const ar_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفاتورة`)
};

const id_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktur`)
};

const it_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fattura`)
};

const ru_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счет`)
};

const pt_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatura`)
};

const ko_invoice = /** @type {(inputs: InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`청구서`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {InvoiceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const invoice = /** @type {((inputs?: InvoiceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InvoiceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoice(inputs)
	if (locale === "es") return es_invoice(inputs)
	if (locale === "fr") return fr_invoice(inputs)
	if (locale === "de") return de_invoice(inputs)
	if (locale === "ja") return ja_invoice(inputs)
	if (locale === "zh") return zh_invoice(inputs)
	if (locale === "ar") return ar_invoice(inputs)
	if (locale === "id") return id_invoice(inputs)
	if (locale === "it") return it_invoice(inputs)
	if (locale === "ru") return ru_invoice(inputs)
	if (locale === "pt") return pt_invoice(inputs)
	return ko_invoice(inputs)
});